module.exports = __webpack_public_path__ + "static/media/Champions.50c765b6.svg";